/**
 * Форматирует номер телефона для отображения.
 * Группирует цифры с конца: 2, 2, 3, 3, остаток — в начало.
 * Примеры:
 *   1234567      → 123 45 67
 *   9991234567   → 999 123 45 67
 *   79991234567  → 7 999 123 45 67
 * Нецифровые символы игнорируются. Не-числовые строки возвращаются без изменений.
 */
export function formatPhone(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (!digits) return value;

  const groups: string[] = [];
  let remaining = digits;

  for (const size of [2, 2, 3, 3]) {
    if (!remaining) break;
    if (remaining.length <= size) {
      groups.unshift(remaining);
      remaining = '';
      break;
    }
    groups.unshift(remaining.slice(-size));
    remaining = remaining.slice(0, -size);
  }

  if (remaining) groups.unshift(remaining);

  return groups.join(' ');
}
